/* eslint-disable import/no-anonymous-default-export */
import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import { pages } from "../../constants/PagePaths";
import styles from "./contactRedesign.module.scss";

const SERVICES = [
  {
    name: "적산",
    desc: "공사의 필요한 단가 및 수량 등을 계산하며, 토목, 조경, 건축 분야 용역을 수행합니다.",
    icon: "calculate",
    color: "#3343e8",
    bg: "rgba(51, 67, 232, 0.07)",
    path: "/requestapplication/integration",
  },
  {
    name: "설계내역",
    desc: "관공서(지자체, 공공기관 등) 수의계약 설계내역작업 의뢰에 대한 용역을 수행합니다.",
    icon: "description",
    color: "#7c3aed",
    bg: "rgba(124, 58, 237, 0.07)",
    path: "/requestapplication/negotiated",
  },
  {
    name: "설계변경",
    desc: "실정 보고서, 검토서, 설계변경 합의서 등 변경에 필요한 도면, 수량, 단가, 내역 작업 용역을 수행합니다.",
    icon: "edit_note",
    color: "#ea580c",
    bg: "rgba(234, 88, 12, 0.07)",
    path: "/requestapplication/designchange",
  },
  {
    name: "서류검토",
    desc: "계약, 설계, 변경 등 각종 공사 서류 및 공무 서류를 검토합니다.",
    icon: "fact_check",
    color: "#059669",
    bg: "rgba(5, 150, 105, 0.07)",
    path: "/requestapplication/documentreview",
  },
  {
    name: "경리서류",
    desc: "각종 계약 서류부터, 준공 서류까지 업무에 필요한 모든 서류를 제작하고 관리합니다.",
    icon: "folder_managed",
    color: "#0284c7",
    bg: "rgba(2, 132, 199, 0.07)",
    path: "/requestapplication/etc",
  },
  {
    name: "공내역서",
    desc: "건설공사에 필요한 내용을 기준으로 합리적인 견적을 산출합니다.",
    icon: "receipt_long",
    color: "#dc2626",
    bg: "rgba(220, 38, 38, 0.07)",
    path: "/requestapplication/estimate",
  },
];

const PROCESS_STEPS = [
  {
    num: 1,
    title: "의뢰 신청",
    desc: "필요한 용역 서비스를 선택하고 의뢰 내용을 작성하여 신청합니다.",
  },
  {
    num: 2,
    title: "전문가 검토",
    desc: "건설 분야 전문가들과 함께 요청받은 의뢰를 면밀히 검토하고 업무 프로세스를 수립합니다.",
  },
  {
    num: 3,
    title: "계약 체결",
    desc: "기간, 예산 등 세부적인 진행 내용을 협의하여 계약을 진행합니다.",
  },
  {
    num: 4,
    title: "결과 납품",
    desc: "의뢰에 최적화된 용역 서비스를 수행하고 결과물을 납품합니다. 지속적인 관리로 비용을 절감합니다.",
  },
];

const TESTIMONIALS = [
  {
    avatar: "/images/ddusul/user1.png",
    title: "콘엑스를 알게 된 후 워라벨이 생겼어요!",
    body: "설계내역을 작성하는 업무를 도맡아 하다 보니 정시퇴근을 하는 날보다 야근하는 날이 더 많았습니다. 콘엑스를 알게 된 후, 회사 직원의 권유로 콘엑스를 사용하게 되었고, 저는 더이상 야근을 하지 않습니다. 집에 빨리 들어가니 와이프도 좋아하고 아이들과 보내는 시간이 더 길어져 삶이 윤택해졌습니다. 콘엑스 담당자 분들께 꼭 감사하다고 인사 전하고 싶습니다.",
  },
  {
    avatar: "/images/ddusul/user2.png",
    title: "더이상 엑셀이 무섭지 않게 되었습니다.",
    body: "엑셀로 내역작업과 설계변경 업무를 하면서, 하나 하나 수정하는 것이 매우 번거로웠습니다. 또한 엑셀에서 계산 실수라도 하는 날이면 눈앞이 깜깜해졌었는데, 콘엑스에서는 자동으로 모든 계산을 해주고 최종 엑셀파일로 변환해주니 너무 쉽고 편하네요. 다른 분들께도 강력 추천 드립니다!",
  },
];

interface Props {}

export default (props: Props) => {
  const history = useHistory();
  const servicesRef = useRef<HTMLElement>(null);

  const scrollToServices = () => {
    servicesRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main id="wrap">
      <article>
        {/* Section 1: Hero */}
        <section className={styles.hero}>
          <div className={styles.heroInner}>
            <div className={styles.heroBadge}>
              <span className={styles.heroBadgeLabel}>전문</span>
              건설 전문 용역
            </div>
            <h1 className={styles.heroTitle}>
              정직한 가격, 신속한 업무처리
              <br />
              콘엑스 용역서비스
            </h1>
            <p className={styles.heroSubtitle}>
              건설 서류 의뢰부터 검토까지, 전문가가 직접 수행합니다.
            </p>
            <div className={styles.heroCta}>
              <a
                className={styles.btnPrimary}
                href={pages.requestapplication}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
                  arrow_forward
                </span>
                빠른 의뢰 신청
              </a>
              <button className={styles.btnOutline} onClick={scrollToServices}>
                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
                  search
                </span>
                서비스 알아보기
              </button>
            </div>
            <div className={styles.trustIndicators}>
              <div className={styles.trustItem}>
                <span className={`material-symbols-outlined ${styles.trustCheck}`}>
                  check_circle
                </span>
                2,140+ 의뢰 실적
              </div>
              <div className={styles.trustItem}>
                <span className={`material-symbols-outlined ${styles.trustCheck}`}>
                  check_circle
                </span>
                전국 지역 대응
              </div>
              <div className={styles.trustItem}>
                <span className={`material-symbols-outlined ${styles.trustCheck}`}>
                  check_circle
                </span>
                평균 7일 납품
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Service Cards */}
        <section className={styles.servicesSection} ref={servicesRef}>
          <div className={styles.sectionInner}>
            <h2 className={styles.sectionTitle}>
              필요한 건설 업무를 선택하세요
            </h2>
            <p className={styles.sectionSubtitle}>
              각 서비스를 클릭하면 바로 의뢰 신청 페이지로 이동합니다.
            </p>
            <div className={styles.servicesGrid}>
              {SERVICES.map((svc) => (
                <div
                  key={svc.path}
                  className={styles.serviceCard}
                  onClick={() => history.push(svc.path)}
                >
                  <div
                    className={styles.serviceIconWrap}
                    style={{ background: svc.bg, color: svc.color }}
                  >
                    <span className="material-symbols-outlined">{svc.icon}</span>
                  </div>
                  <div className={styles.serviceName}>{svc.name}</div>
                  <div className={styles.serviceDesc}>{svc.desc}</div>
                  <div className={styles.serviceFooter}>
                    <span className={`material-symbols-outlined ${styles.serviceArrow}`}>
                      arrow_forward
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 3: Process */}
        <section className={styles.processSection}>
          <div className={styles.sectionInner}>
            <h2 className={styles.sectionTitle}>
              간편한 4단계 진행 프로세스
            </h2>
            <p className={styles.sectionSubtitle}>
              의뢰부터 납품까지, 체계적인 프로세스로 진행됩니다.
            </p>
            <div className={styles.processGrid}>
              {PROCESS_STEPS.map((step) => (
                <div key={step.num} className={styles.processStep}>
                  <div className={styles.processNumber}>{step.num}</div>
                  <h3 className={styles.processTitle}>{step.title}</h3>
                  <p className={styles.processDesc}>{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 4: Testimonials */}
        <section className={styles.testimonialSection}>
          <div className={styles.sectionInner}>
            <div className={styles.testimonialHeader}>
              <h2 className={styles.sectionTitle}>
                써보면, 확실히 다릅니다.
              </h2>
              <p className={styles.sectionSubtitle}>
                한번도 안써본 사람은 있지만, 한번만 써본 사람은 없습니다.
              </p>
            </div>
            <div className={styles.testimonialGrid}>
              {TESTIMONIALS.map((t, i) => (
                <div key={i} className={styles.testimonialCard}>
                  <div className={styles.testimonialQuote}>"</div>
                  <div className={styles.testimonialTop}>
                    <img
                      className={styles.testimonialAvatar}
                      src={t.avatar}
                      alt="사용자"
                    />
                    <div className={styles.testimonialName}>{t.title}</div>
                  </div>
                  <div className={styles.testimonialBody}>{t.body}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 5: Bottom CTA */}
        <section className={styles.ctaBanner}>
          <div className={styles.ctaInner}>
            <div className={styles.ctaText}>
              지금 바로 용역을 의뢰하세요
            </div>
            <a
              className={styles.ctaButton}
              href={pages.requestapplication}
            >
              의뢰 신청하기
              <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
                arrow_forward
              </span>
            </a>
          </div>
        </section>
      </article>
    </main>
  );
};
